import Vue from 'vue';
import flywheelSFMCUtilFactory from "@/services/flywheel-sfmc-util"
import ProcessStatus from "@/services/process-status"

var FlywheelFolderService;

Vue.util.extend(
    (FlywheelFolderService = function(component) {
        this.flywheelFolderUtil = flywheelSFMCUtilFactory(component, "folder");
    }).prototype,
    {
        STATE_UNPROCESSED: "unprocessed",
        STATE_QUEUED: "queued",
        STATE_PROCESSED: "processed",
        folderAdd: function(id, label, rootFolderName) {
            return {
                id: id,
                processStatus: new ProcessStatus(this.STATE_UNPROCESSED),
                label: label,
                rootFolderName: rootFolderName,
                path: ""
            };
        },
        processFolder: function(campaignName, folder) {
            var processStatus = folder.processStatus;
            return this.flywheelFolderUtil.apiCall("create_path", {
                path: `${folder.path}/${campaignName}`
            })
            .then(
                () => {
                    processStatus.state = this.STATE_PROCESSED;
                    return Promise.resolve();
                },
                (errorResponse) => {
                    processStatus.state = this.STATE_UNPROCESSED;
                    processStatus.error(errorResponse.apiResponseMessage, errorResponse.apiResponseRaw);
                    return Promise.resolve();
                }
            )
        },
        processFolders: function(campaignName, folders) {
            var folderTgts = [];
            var processIter = () => {
                if (folderTgts.length) {
                    return this.processFolder(campaignName, folderTgts.shift())
                    .then(
                        () => processIter()
                    );
                } else {
                    return Promise.resolve();
                }
            };
            Object.keys(folders).forEach(k => {
                var folder = folders[k]
                if (
                    (folder.processStatus.state == this.STATE_UNPROCESSED) &&
                    folder.path
                ) {
                    folder.processStatus.state = this.STATE_QUEUED;
                    folder.processStatus.reset();
                    folderTgts.push(folder);
                }
            });
            return processIter();
        }
    }
);

export default function(component) {
    return new FlywheelFolderService(component);
}